module.exports = __webpack_public_path__ + "media/bootstrap-icons/hand-thumbs-up-6428b0a3.svg";